
import React from 'react';
import { Star } from 'lucide-react';

interface TestimonialProps {
  quote: string;
  author: string;
  stars: number;
  type: string;
}

const Testimonial = ({ quote, author, stars, type }: TestimonialProps) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
      <div className="flex mb-3">
        {[...Array(5)].map((_, i) => (
          <Star 
            key={i} 
            className={`w-5 h-5 ${i < stars ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'} mr-1`} 
          />
        ))}
      </div>
      <p className="text-gray-700 italic mb-4">"{quote}"</p>
      <div>
        <p className="font-semibold">{author}</p>
        <p className="text-sm text-gray-500">{type}</p>
      </div>
    </div>
  );
};

const AdultBeginnerTestimonials = () => {
  const testimonials = [
    {
      quote: "Jeg har altid ønsket at lære at spille klaver, men troede det var for sent. Oscar har vist mig, at alder bare er et tal, når det kommer til at lære musik. Hans tålmodighed og opmuntring har været afgørende for min progression.",
      author: "Henrik Larsen",
      stars: 5,
      type: "Voksen begynder, 52 år"
    },
    {
      quote: "Oscars tilgang til voksne begyndere er så respektfuld og effektiv. Han forstår, at vi har andre forpligtelser og begrænset tid til at øve, men formår alligevel at sikre, at vi gør konstante fremskridt.",
      author: "Charlotte Nielsen",
      stars: 5,
      type: "Voksen begynder, 38 år"
    },
    {
      quote: "Efter kun 6 måneder med Oscar kan jeg spille sange, jeg aldrig troede var mulige for en begynder. Hans fokus på praktiske færdigheder og 'rigtig musik' frem for endeløse tørre øvelser har holdt min motivation i top.",
      author: "Anders Madsen",
      stars: 5,
      type: "Voksen begynder, 45 år"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-serif font-bold mb-4">
            Erfaringer fra voksne begyndere
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Hør fra andre voksne, der har taget springet og oplevet glæden ved at lære klaver senere i livet.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Testimonial 
              key={index}
              quote={testimonial.quote}
              author={testimonial.author}
              stars={testimonial.stars}
              type={testimonial.type}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdultBeginnerTestimonials;
